import * as React from "react"
import {Link as RouterLink} from "react-router-dom";
import {Box, Link} from "@mui/material"
import {IconSeeker, PopoverSeekerItem} from "@ui-seeker/core";

import {TitleWithPopover} from "@components";
import {REPRICING_ROUTES} from "@constants";
import {useRepricingAlerts} from "../../@hooks";


export default function RepricingAlertCardTitle({ alertID, name, haveMails, data={} }) {
    const { handleChecker, handleCopy, handleEdit, handleDelete, isLoadingItem } = useRepricingAlerts(data)

    return <Box sx={{ display: 'flex', alignItems: 'center' }} className={isLoadingItem ? "is-loading" : ''}>
        <TitleWithPopover title={name} enabledExcel={false} enabledPDF={false} forceClosePopover={isLoadingItem} showIcon>
            <PopoverSeekerItem icon="memo-circle-check" label="Check auto price" onClick={handleChecker} />
            <Link component={RouterLink} to={REPRICING_ROUTES.FORM_PATH}>
                <PopoverSeekerItem icon="copy" label="Duplicate" onClick={handleCopy} />
            </Link>
            <Link component={RouterLink} to={REPRICING_ROUTES.FORM_PATH}>
                <PopoverSeekerItem icon="pen" label="Configuration" onClick={handleEdit} />
            </Link>
            <PopoverSeekerItem icon="trash-can" label="Delete" onClick={handleDelete} />
        </TitleWithPopover>

        { !!haveMails && <IconSeeker icon='envelope' iconWeight='light' color='primary.main' /> }
    </Box>
}